/**
 * PIN session unlock (RL11 soft-reload).
 *
 * Survives F5 / soft reload via sessionStorage, but not app quit / new window.
 * Idle lock and full logout must clear this so CodeEntry is required again.
 */

import { sessionGet, sessionSet, sessionRemove } from '../infrastructure/storage/sessionAccess';
import { normalizeBusinessStorageId } from './sharedCore';

export const ROLE_PIN_SESSION_KEY = 'rolePinSession';

/**
 * @param {string|null|undefined} businessId
 */
export function markRolePinUnlocked(businessId) {
  const bid = normalizeBusinessStorageId(businessId);
  if (!bid) return;
  sessionSet(ROLE_PIN_SESSION_KEY, { businessId: bid, at: Date.now() });
}

export function clearRolePinSession() {
  sessionRemove(ROLE_PIN_SESSION_KEY);
}

/**
 * @param {string|null|undefined} businessId
 * @returns {boolean}
 */
export function isRolePinSessionActive(businessId) {
  const bid = normalizeBusinessStorageId(businessId);
  if (!bid) return false;
  const raw = sessionGet(ROLE_PIN_SESSION_KEY);
  if (!raw || typeof raw !== 'object') return false;
  return normalizeBusinessStorageId(raw.businessId) === bid;
}
